"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const Layout_1 = require("../Layout");
const Text_1 = require("../Text");
const react_1 = __importDefault(require("react"));
const Yup = __importStar(require("yup"));
const Formik_1 = require("../Formik");
const components_1 = require("./components");
const String_1 = require("../String");
const react_i18next_1 = require("react-i18next");
const getErrorsFromValidationError = (validationError) => {
    // taken from https://itnext.io/simple-react-form-validation-with-formik-yup-and-or-spected-206ebe9e7dcc
    return validationError.inner.reduce((errors, error) => {
        return {
            ...errors,
            [error.path || "no_path"]: error.errors[0],
        };
    }, {});
};
const LoginForm = ({ signInRequest, forgottenPasswordRequest, resetPasswordRequest, viewState, onViewChanged, }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const titles = {
        "sign-in": t("label-signIn"),
        "forgotten-password": t("label-resetPassword"),
        "create-new-password": t("label-newPassword"),
    };
    const loginFormSchema = Yup.object().shape({
        email: Yup.string().trim().required(t("validation-required")),
        password: Yup.string().trim().required(t("validation-required")),
    });
    const forgotPasswordFormSchema = Yup.object().shape({
        email: Yup.string()
            .trim()
            .email(t("validation-enterAValidEmail"))
            .required(t("validation-required")),
    });
    const resetPasswordFormSchema = Yup.object().shape({
        newPassword: Yup.string()
            .trim()
            .required(t("validation-required"))
            .min(12, t("validation-newPasswordMin", { characters: 12 }))
            .max(128, t("validation-newPasswordMax", { characters: 128 }))
            .test("passwords-match", t("validation-passwordsMustMatch"), function (value) {
            return this.parent.password !== value;
        }),
        confirmPassword: Yup.string()
            .trim()
            .oneOf([Yup.ref("newPassword"), undefined], t("validation-passwordsMustMatch"))
            .required(t("validation-passwordsMustMatch")),
    });
    return (react_1.default.createElement(components_1.LoginOuterPanel, { rounded: true, shineAndShadow: true },
        react_1.default.createElement("div", { style: {
                marginLeft: "20px",
                height: "40px",
                display: "flex",
                alignItems: "center",
            } },
            react_1.default.createElement(components_1.LoginHeading, null, titles[viewState])),
        viewState === "sign-in" && (react_1.default.createElement(Formik_1.Formik, { initialValues: {
                email: "",
                password: "",
            }, onSubmit: signInRequest, validationSchema: loginFormSchema, validateOnBlur: false },
            react_1.default.createElement(Formik_1.Form, null,
                react_1.default.createElement(components_1.LoginInnerPanel, { rounded: true, shineAndShadow: true },
                    react_1.default.createElement(components_1.LoginFieldWrapper, null,
                        react_1.default.createElement(Formik_1.Field, { name: "email", label: t("label-emailAddress"), type: "text" }),
                        react_1.default.createElement(Formik_1.Field, { name: "password", label: t("label-password"), type: "password" }),
                        react_1.default.createElement(Layout_1.FlexSpace, null),
                        react_1.default.createElement(Text_1.Link, { style: {
                                marginLeft: "0px",
                                padding: "5px 5px 5px 0px ",
                                width: "fit-content",
                            }, onClick: () => {
                                onViewChanged && onViewChanged("forgotten-password");
                            }, "data-testid": "link-forgotPassword" }, t("label-forgotPassword")))),
                react_1.default.createElement("div", { style: { margin: "10px" } },
                    react_1.default.createElement(Formik_1.FormSubmit, { height: 40, label: "sign in button", dataTestId: "button-signIn" }, t("label-signIn")))))),
        viewState === "forgotten-password" && (react_1.default.createElement(Formik_1.Formik, { enableReinitialize: true, initialValues: {
                email: "",
            }, onSubmit: ({ email }) => {
                forgottenPasswordRequest(email);
                localStorage.setItem("path", "reset-password");
                onViewChanged && onViewChanged("sign-in");
            }, validationSchema: forgotPasswordFormSchema, validate: (values) => {
                try {
                    // Remove tenancy from email before validation
                    forgotPasswordFormSchema.validateSync({
                        ...values,
                        email: (0, String_1.removeTenancyFromEmailAddress)(values.email),
                    }, { abortEarly: false });
                    return {};
                }
                catch (errors) {
                    return getErrorsFromValidationError(errors);
                }
            } },
            react_1.default.createElement(Formik_1.Form, null,
                react_1.default.createElement(components_1.LoginInnerPanel, { rounded: true, shineAndShadow: true },
                    react_1.default.createElement(components_1.LoginFieldWrapper, null,
                        react_1.default.createElement(Formik_1.Field, { name: "email", label: t("label-emailAddress"), type: "text" }))),
                react_1.default.createElement("div", { style: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "auto auto",
                        margin: "10px",
                    } },
                    react_1.default.createElement(Text_1.Link, { onClick: () => {
                            onViewChanged && onViewChanged("sign-in");
                        }, style: {
                            marginLeft: "10px",
                            padding: "5px 5px 5px 0px ",
                            width: "fit-content",
                        }, "data-testid": "link-return" }, t("label-returnToSignIn")),
                    react_1.default.createElement(Formik_1.FormSubmit, { height: 40, label: "reset password button", dataTestId: "button-submit" }, t("label-submit")))))),
        viewState === "create-new-password" && (react_1.default.createElement(Formik_1.Formik, { initialValues: {
                newPassword: "",
                confirmPassword: "",
            }, onSubmit: ({ newPassword }) => (resetPasswordRequest && resetPasswordRequest(newPassword),
                localStorage.removeItem("path")), validationSchema: resetPasswordFormSchema },
            react_1.default.createElement(Formik_1.Form, null,
                react_1.default.createElement(components_1.LoginInnerPanel, { rounded: true, shineAndShadow: true },
                    react_1.default.createElement(components_1.LoginFieldWrapper, null,
                        react_1.default.createElement(Formik_1.Field, { label: t("label-newPassword"), name: "newPassword", type: "password" }),
                        react_1.default.createElement(Formik_1.Field, { label: t("label-repeatPassword"), name: "confirmPassword", type: "password" }))),
                react_1.default.createElement("div", { style: {
                        display: "grid",
                        alignItems: "center",
                        gridTemplateColumns: "auto auto",
                        margin: "10px",
                    } },
                    react_1.default.createElement(Text_1.Link, { style: {
                            marginLeft: "10px",
                            padding: "5px 5px 5px 0px ",
                            width: "fit-content",
                        }, onClick: () => {
                            onViewChanged && onViewChanged("sign-in");
                        }, "data-testid": "link-return" }, t("label-returnToSignIn")),
                    react_1.default.createElement(Formik_1.FormSubmit, { height: 40, label: "update password button", dataTestId: "button-update" }, t("label-updatePassword"))))))));
};
exports.LoginForm = LoginForm;
//# sourceMappingURL=index.js.map